import CaretDown from '@/assets/icons/caret-down.svg?react';
import { TopbarConfigItem } from '@/components/elements/topbar/topbar.component';
import { topbarLocators } from '@/components/elements/topbar/topbar.locators';
import { topBarTranslations } from '@/components/elements/topbar/topbar.messages';
import { T } from '@/components/i18n/message.i18n.component';
import { NavigateFunction } from 'react-router-dom';

export const templatePretailorTopbarConfig = (
  navigate: NavigateFunction,
  progress: number,
  id: string,
): TopbarConfigItem[] => [
  {
    side: 'left',
    type: 'button',
    testId: topbarLocators.topbarTemplatesPretailoringButtonBackToProducts,
    variant: 'ghost',
    text: (
      <>
        <CaretDown className="mr-2 rotate-90" />
        <T {...topBarTranslations.backToTemplates} />
      </>
    ),
    onClick: () => {
      navigate('/templates');
    },
  },
  {
    side: 'left',
    type: 'step',
    variant: 'default',
    testId: topbarLocators.topbarTemplatesPretailoringButtonStep1,
    text: <T {...topBarTranslations.pretailoringButton} />,
    index: 1,
    progress: progress,
    onClick: () => {
      navigate(`/template/${id}/pre-tailoring`);
    },
  },
  {
    side: 'left',
    type: 'step',
    variant: 'disabled',
    testId: topbarLocators.topbarTemplatesPretailoringButtonStep2,
    text: <T {...topBarTranslations.tailoringButton} />,
    index: 2,
    progress: 0,
    onClick: () => {
      navigate(`/template/${id}/final-tailoring`);
    },
  },
  {
    side: 'right',
    type: 'button',
    variant: 'secondary',
    testId: topbarLocators.topbarTemplatesPretailoringButtonNext,
    text: <T {...topBarTranslations.saveButton} />,
    buttonType: 'submit',
    form: 'hook-form',
    onClick: () => {
      navigate(`/template/${id}/final-tailoring`);
    },
  },
];
